module.exports = __webpack_public_path__ + "static/media/index_ad.787d32f2.jpg";